import { Button, type ButtonProps } from '@mui/material';

type RoundButtonProps = ButtonProps & {
  children: Readonly<React.ReactNode>;
};

export default function RoundButton({ children, ...props }: RoundButtonProps) {
  return (
    <Button
      {...props}
      sx={{
        ...props.sx,
        height: 44,
        borderRadius: 22,
      }}
    >
      {children}
    </Button>
  );
}
